import { ModalInfo } from '@/components/TextTips';
import { getCorrespondLabel } from './global';
import ToastUtils from './ToastUtils';
import { Button } from 'antd';

//获取实名认证的参数--在定义路由的时候传类型
export const getParams = (props) => {
    const { params, searchParams, realNameType } = props;
    if (realNameType === 'exam') {
        return {
            business_id: searchParams.get('relationId') || searchParams.get('businessId'),
            template_id: searchParams.get('relationTemplateId') || searchParams.get('templateId')
        };
    }
    if (realNameType === 'practise' || realNameType === 'researchResult') {
        return {
            business_id: searchParams.get('relationId'),
            template_id: searchParams.get('relationTemplateId')
        };
    }
    if (realNameType === 'project') {
        return {
            business_id: params.businessId,
            template_id: params.templateId
        };
    }
    if (realNameType === 'notice-detail') {
        return {
            business_id: params.business_id,
            template_id: params.template_id
        };
    }
    if (realNameType === 'player' || realNameType === 'community' || realNameType === 'knowledge-graph') {
        return {
            business_id: searchParams.get('business_id'),
            template_id: searchParams.get('template_id')
        };
    }
    if (realNameType === 'openCourse') {
        return {
            business_id: params.businessId,
            template_id: 101
        };
    }
    if (realNameType === 'activity') {
        return {
            business_id: searchParams.get('relation_business_id'),
            template_id: searchParams.get('relation_template_id')
        };
    }
    return {
        business_id: null,
        template_id: null
    };
};
export const tipObj = (props) => {
    let params = getParams(props);
    if (!params) {
        return false;
    }

    let templateId = params.relationTemplateId || params.template_id,
        label = '返回' + getCorrespondLabel([templateId]) + '列表',
        path = `/user-center/${templateId}`;
    return {
        params,
        label,
        path
    };
};
export const realNameToastTip = () => {
    ToastUtils.showAbnormalToast('请先前往App完成实名');
};
export const refreshPage = () => {
    window.location.reload();
};
export const realNameTip = (tipData, navigate) => {
    window.modalInfo = ModalInfo({
        getContainer: function () {
            return document.getElementById('other-modal-root');
        },
        msg: '请先前往App完成实名',
        tipFooter: (
            <div>
                <div>
                    <Button
                        onClick={() => {
                            if (window.modalInfo) {
                                window.modalInfo.destroy();
                            }
                            navigate(tipData.path);
                        }}
                        type="primary"
                    >
                        {tipData.label}
                    </Button>
                    <div onClick={refreshPage} style={{ marginTop: '8px' }}>
                        我已完成认证， <span style={{ color: '#2750D9', cursor: 'pointer' }}>刷新页面</span>{' '}
                    </div>
                </div>
            </div>
        )
    });
};
